import { useAgentSdk } from "./useAgentSdk";

/** return site assigned to worker */
export function useAgentSite() {
    return useAgentSdk().getAgentSite();
}
